define( function() {
	"use strict";

	return ( /\?/ );
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/ajax/var/rquery.js
// module id = 71
// module chunks = 0